
// Firebase configuration
module.exports =  {
    apiKey: "AIzaSyCuPPo_U547os2r8jS8zQx12iU6SIu9THk",
    authDomain: "react-app-course-1288e.firebaseapp.com",
    projectId: "react-app-course-1288e",
    storageBucket: "react-app-course-1288e.appspot.com",
    messagingSenderId: "835876223016",
    appId: "1:835876223016:web:b7107fcd7c4ea459bd9d1d"
}
  